module.exports = __webpack_public_path__ + "static/about-hero-f539a028d4376c3101505d0a6011b792.jpg";